module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view/reclamation-view/reclamation-view.component.css
// module id = ./src/app/view/reclamation-view/reclamation-view.component.css
// module chunks = main